import { createSlice } from '@reduxjs/toolkit'
import placeholderLogo from 'media/placeholder_kinesis_logo.png'

// Initial state
const initialState = {
    id: null,
    auth0UserId: null,
    firstName: null,
    lastName: null,
    type: null,
    email: null,
    picture: null,
    auth0ConnectionValid: null,
    onboarded: null,
    organizationId: null,
    organizationName: null,
    organizationCode: null,
    organizationLogo: null,
    organizationWebsite: '',
    organizationHandlesMembership: null,
    requirePaymentMethodToInviteAthletes: null,
    organizationAdminStripeCustomerId: null,
    doesOrganizationHaveAtleastOnePayingAthlete: false,
    numberOfAssessmentInvitesSent: 0,
    freeAssessmentInviteExpirationTimestamp: null,
    enableCoachRunningWorkouts: null,
    enableKinesisUserGroups: null,
    requireEmailToCreateAthleteAccount: null,
    isFinalSurgeIntegrationActive: false, // TODO: deprecate
    isTrainingPeaksIntegrationActive: false,
    adminToolsVisible: true
}

// User Slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {

      state.id = action.payload.id;
      state.auth0UserId = action.payload.auth0UserId;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.type = action.payload.type;
      state.email = action.payload.email;
      state.picture = action.payload.picture;
      state.auth0ConnectionValid = action.payload.auth0ConnectionValid;
      state.onboarded = action.payload.onboarded;
      state.organizationId = action.payload.organizationId;
      state.organizationName = action.payload.organizationName;
      state.organizationCode = action.payload.organizationCode;
      state.organizationLogo = action.payload.organizationLogo || placeholderLogo;
      state.organizationWebsite = action.payload.organizationWebsite || '';
      state.organizationHandlesMembership = action.payload.organizationHandlesMembership;
      state.requirePaymentMethodToInviteAthletes = action.payload.requirePaymentMethodToInviteAthletes;
      state.organizationAdminStripeCustomerId = action.payload.organizationAdminStripeCustomerId;
      state.doesOrganizationHaveAtleastOnePayingAthlete = action.payload.doesOrganizationHaveAtleastOnePayingAthlete;
      state.numberOfAssessmentInvitesSent = action.payload.numberOfAssessmentInvitesSent;
      state.freeAssessmentInviteExpirationTimestamp = action.payload.freeAssessmentInviteExpirationTimestamp;
      state.enableCoachRunningWorkouts = action.payload.enableCoachRunningWorkouts;
      state.enableKinesisUserGroups = action.payload.enableKinesisUserGroups;
      state.requireEmailToCreateAthleteAccount = action.payload.requireEmailToCreateAthleteAccount;
      state.isTrainingPeaksIntegrationActive = action.payload.isTrainingPeaksIntegrationActive;

    },
    updateOrganizationDetails: (state, action) => {
      if (action.payload.organizationName !== undefined) {
        state.organizationName = action.payload.organizationName;
      }
      if (action.payload.organizationWebsite !== undefined) {
        state.organizationWebsite = action.payload.organizationWebsite;
      }
      if (action.payload.organizationLogo !== undefined) {
        state.organizationLogo = action.payload.organizationLogo || placeholderLogo;
      }
    },
    updateUserDetails: (state, action) => {
      if (action.payload.firstName !== undefined) {
        state.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.lastName = action.payload.lastName;
      }
    },
    setTrainingPeaksIntegrationActive: (state, action) => { state.isTrainingPeaksIntegrationActive = action.payload; },
    setAdminToolsVisible: (state, action) => { state.adminToolsVisible = action.payload; },
    resetUserState: () => initialState
  },
});

export const { 
  setUserInfo,
  updateOrganizationDetails,
  updateUserDetails,
  setTrainingPeaksIntegrationActive,
  setAdminToolsVisible,
  resetUserState 
} = userSlice.actions;

export default userSlice.reducer;